import { Component, ChangeDetectionStrategy, ElementRef, Input, ViewChild } from '@angular/core';
import { MdlTooltipComponent } from '@angular-mdl/core';

@Component({
    selector: 'covance-tooltip',
    template: require('./covance-tooltip.component.html'),
    styles: [require('./covance-tooltip.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CovanceTooltipComponent {
    @ViewChild('resultContent')
    public resultContent: ElementRef;

    @ViewChild('tooltip')
    public tooltipComponent: MdlTooltipComponent;

    @Input()
    public alwaysShow = false;

    public onMouseOver(event: any) {
        const target = event.target as HTMLElement;
        if (target.classList.contains('hide-tooltip') || target.closest('.hide-tooltip')) {
            return;
        }
        const element = this.resultContent.nativeElement.firstElementChild;
        if (this.alwaysShow || (element.offsetWidth < element.scrollWidth)) {

            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            const elementBottom = element.getBoundingClientRect().bottom;
            const tooltipComponentHeight = this.tooltipComponent.element.clientHeight;
            if (windowHeight < elementBottom + tooltipComponentHeight + 20) {
                this.tooltipComponent.position = 'top';
            } else {
                this.tooltipComponent.position = 'bottom';
            }

            this.tooltipComponent.mouseEnter(event);
        }
    }

    public onMouseLeave() {
        this.tooltipComponent.mouseLeave();
    }
}